import { defineComponent } from 'vue';
import Tooltip from './Tooltip';
import useConfigInject from '../_util/hooks/useConfigInject';
const imageOperationTipProps = () => ({
    title: String
});
const ImageOperationTip = defineComponent({
    name: 'ImageOperationTip',
    props: imageOperationTipProps(),
    setup(props, { slots }) {
        const { prefixCls } = useConfigInject('tooltip', props);
        return () => (<Tooltip placement="bottom" v-slots={{
                title: props.title
            }} overlayClassName={`${prefixCls.value}-image-operation`}>
        {slots.default?.()}
      </Tooltip>);
    }
});
export default ImageOperationTip;
